import React from 'react';
import { WrenchIcon, DownloadIcon, ShieldCheckIcon, InfinityIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const badges = [{
  icon: DownloadIcon,
  label: 'Instant Download'
}, {
  icon: CreditCardIcon,
  label: 'One-Time Payment'
}, {
  icon: InfinityIcon,
  label: 'Lifetime Access'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-ink-950" data-id="element-195" data-mp="quubrfeq8yle">
      <div className="pointer-events-none absolute inset-0 opacity-[0.07]" style={{
      backgroundImage: 'repeating-linear-gradient(90deg, #ffffff 0 1px, transparent 1px 44px), repeating-linear-gradient(0deg, #ffffff 0 1px, transparent 1px 44px)'
    }} aria-hidden="true" data-id="element-196" data-mp="qt9hzs08ljol" />
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-10 pt-8 sm:px-6 sm:pb-14 sm:pt-12" data-id="element-197" data-mp="1aj3g0ntjov19">
        <div className="flex items-center justify-center gap-2" data-id="element-198" data-mp="9oc8wp7gdxj9">
          <WrenchIcon className="h-5 w-5 text-gold-500" aria-hidden="true" data-id="element-199" data-mp="9lg9ewfyj0sp" />
          <span className="font-display text-lg font-extrabold uppercase tracking-[0.12em] text-white sm:text-xl" data-id="element-200" data-mp="4nepk9apixg6">
            Premium Technician Kit<span className="text-gold-500" data-id="element-201" data-mp="3rtp746drgwtl">™</span>
          </span>
        </div>

        <div className="mt-6 grid items-center gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-12" data-id="element-202" data-mp="3rvs63fww60ag">
          <div className="order-2 lg:order-1" data-id="element-203" data-mp="sgeu8dv1i1zu">
            <p className="text-center font-display text-xs font-bold uppercase tracking-[0.18em] text-gold-400 sm:text-sm lg:text-left" data-id="element-204" data-mp="nexuwms7enld">
              The professional service system for appliance repair technicians
            </p>

            <h1 className="mt-3 text-center font-display text-[2.1rem] font-extrabold uppercase leading-[0.95] text-white sm:text-5xl lg:text-left lg:text-[3.4rem]" data-id="element-205" data-mp="emnh6vi3nzzd">
              Professionalize your appliance repair business in{' '}
              <span className="text-gold-500" data-id="element-206" data-mp="30lxiana1wz31">7 days</span>
            </h1>

            <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-steel-300 sm:text-lg lg:mx-0 lg:text-left" data-id="element-207" data-mp="30o0clji8ledk">
              With ready-to-use tools to quote jobs, manage customers, deliver
              professional service, and get paid with confidence — even if you’re
              still working alone and don’t have a huge customer base.
            </p>

            <p className="mx-auto mt-4 max-w-xl rounded-lg border-l-4 border-gold-500 bg-white/[0.05] px-4 py-3 text-center text-sm font-semibold text-white sm:text-base lg:mx-0 lg:text-left" data-id="element-208" data-mp="2hu4k8eg4knog">
              6 premium volumes, 5 exclusive bonus systems, and dozens of
              ready-to-customize templates, scripts, checklists, forms, and
              customer-facing tools.
            </p>

            <div id="hero-cta" className="mx-auto mt-6 max-w-xl lg:mx-0" data-id="element-209" data-mp="66oh2umff1aq">
              <CTAButton label="Get the Premium Technician Kit™" sub="Instant Download · One-Time Payment · Lifetime Access · 7-Day Guarantee" data-id="element-210" data-mp="b3x1z2yyljfo" />
            </div>

            <div className="mx-auto mt-6 max-w-xl rounded-2xl border border-white/10 bg-ink-900/80 p-4 lg:mx-0" data-id="element-211" data-mp="1qp8oo6dbiqg0">
              <Countdown data-id="element-212" data-mp="25e4vy17jvzfk" />
              <div className="mt-4" data-id="element-213" data-mp="20m3oqtp8oywe">
                <ScarcityBar data-id="element-214" data-mp="20ltzx9fxkxsa" />
              </div>
              <p className="mt-3 text-center text-[11px] font-medium text-steel-500" data-id="element-215" data-mp="20kag58v2g4lr">
                Your currency is converted automatically based on your location.
              </p>
            </div>
          </div>

          <div className="order-1 lg:order-2" data-id="element-216" data-mp="2oboblnoikgay">
            <img src="https://cdn.magicpatterns.com/uploads/prSoMHDmtvDgoERMLEMTCp/TECHNICIAN-EN.png" alt="Everything included in the Premium Technician Kit: six premium volumes, five bonus systems, and ready-to-use templates" className="mx-auto w-full max-w-[560px]" width={1080} height={1080} data-id="element-217" data-mp="2oad2d8caugcg" />
          </div>
        </div>

        <ul className="mt-8 grid grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-218" data-mp="qf7ndrus4p9f">
          {badges.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center justify-center gap-2 rounded-lg border border-white/10 bg-white/[0.04] px-2 py-2.5 text-center" data-id="element-219" data-mp="vgnb5rocd9vi">
              <Icon className="h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-220" data-mp="15axcvzz6bkiw" />
              <span className="text-[11px] font-bold uppercase tracking-wide text-white sm:text-xs" data-id="element-221" data-mp="7r2rt7oa0alp">
                {label}
              </span>
            </li>)}
        </ul>
      </div>
    </header>;
}